window.requestIdleCallback =
	window.requestIdleCallback ||
	function (cb) {
		return setTimeout(cb, 3000);
	};

window.cancelIdleCallback =
	window.cancelIdleCallback ||
	function (requestId) {
		window.clearTimeout(requestId);
	};

if (!Math.sign) {
	Math.sign = function (x) {
		return (x > 0) - (x < 0) || +x;
	};
}
